import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import messages from 'intl/messages';
import { ANALYTICS_ID } from 'config';
import { Helmet } from '@games/ui';

export const HelmetHeaders: React.FC = () => {
  const { locale, formatMessage } = useIntl();
  const siteMetas = useMemo(() => {
    return [
      { name: 'keywords', content: formatMessage(messages.metaKeywords) },
      { name: 'description', content: formatMessage(messages.metaDescription) },
      { name: 'og:url', content: window.location.href },
      { name: 'og:type', content: 'website' },
      {
        name: 'og:image',
        content: 'https://www.nonogramsonline.com/nonogram.jpg',
      },
    ];
  }, [locale, formatMessage]);
  return (
    <Helmet
      title='Nonograms Online'
      metas={siteMetas}
    >
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${ANALYTICS_ID}`}
      />
      <script>{`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', '${ANALYTICS_ID}');
      `}</script>
    </Helmet>
  );
};

export default HelmetHeaders;
